import React from 'react';
import { EXPERIENCE } from '../../data/config';
import { MapPin, Calendar, CheckCircle2 } from 'lucide-react';

const Experience = () => {
  return (
    <section id="experience" className="section-container">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 gradient-text">Work Experience</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-coffee-500 to-coffee-300 mx-auto mb-4"></div>
          <p className="text-coffee-200 text-lg">
            Building scalable systems and leading high-performance teams
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-coffee-500 via-coffee-600 to-coffee-700"></div>

          {/* Experience Items */}
          <div className="space-y-12">
            {EXPERIENCE.map((exp, index) => (
              <div
                key={exp.id}
                className={`relative flex items-center ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Timeline Dot */}
                <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-6 h-6 bg-coffee-300 rounded-full border-4 border-coffee-900 z-10 shadow-lg shadow-coffee-300/50"></div>

                {/* Content Card */}
                <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'}`}>
                  <div className="glass-card-hover p-6 md:p-8">
                    {/* Company Header */}
                    <div className="flex items-start gap-4 mb-4">
                      <div className="text-4xl flex-shrink-0">
                        {exp.logo.startsWith('http') ? (
                          <img 
                            src={exp.logo} 
                            alt={`${exp.company} logo`}
                            className="w-12 h-12 object-contain rounded-lg"
                          />
                        ) : (
                          exp.logo
                        )}
                      </div>
                      <div className="flex-1">
                        <h3 className="text-2xl font-bold text-cream-100 mb-1">
                          {exp.company}
                        </h3>
                        <div className="text-lg font-semibold text-coffee-300 mb-2">
                          {exp.role}
                        </div>
                        <div className="flex flex-wrap gap-3 text-sm text-coffee-200">
                          <span className="flex items-center gap-1">
                            <Calendar className="w-4 h-4" />
                            {exp.period}
                          </span>
                          <span className="flex items-center gap-1">
                            <MapPin className="w-4 h-4" />
                            {exp.location}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-coffee-100 mb-4 italic">
                      {exp.description}
                    </p>

                    {/* Achievements */}
                    <div className="mb-4">
                      <h4 className="text-sm font-semibold text-coffee-200 mb-3">
                        Key Achievements:
                      </h4>
                      <ul className="space-y-2">
                        {exp.achievements.map((achievement, i) => (
                          <li key={i} className="flex items-start gap-2">
                            <CheckCircle2 className="w-4 h-4 text-coffee-300 flex-shrink-0 mt-1" />
                            <span className="text-coffee-100 text-sm">{achievement}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Tech Stack */}
                    <div className="flex flex-wrap gap-2">
                      {exp.techStack.map((tech, i) => (
                        <span key={i} className="tech-badge">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
